export const ACCOUNT_DREAME = 'DREAME';
export const ACCOUNT_MEGELIN = 'MEGELIN';
export const ACCOUNT_ALL = 'ALL';

export const MEGELIN_EIDS = ['202500718', '202500719', '202500123'];
export const MEGELIN_UIDS = ['F7158D94', '37F29794', '27898894'];

export const MEGELIN_EID_SET = new Set(MEGELIN_EIDS);
export const MEGELIN_UID_SET = new Set(MEGELIN_UIDS);

export const ACCOUNT_OPTIONS = [
  { value: ACCOUNT_DREAME, label: 'DREAME' },
  { value: ACCOUNT_MEGELIN, label: 'MEGELIN' },
];

export const TL_ACCOUNT_OPTIONS = [
  { value: ACCOUNT_DREAME, label: 'DREAME' },
  { value: ACCOUNT_MEGELIN, label: 'MEGELIN' },
  { value: ACCOUNT_ALL, label: 'ALL' },
];

export function normalizeAccount(value) {
  const upper = String(value || ACCOUNT_DREAME).trim().toUpperCase();
  return upper === ACCOUNT_MEGELIN ? ACCOUNT_MEGELIN : ACCOUNT_DREAME;
}

export function normalizeTlAccount(value) {
  const upper = String(value || ACCOUNT_DREAME).trim().toUpperCase();
  if (upper === ACCOUNT_MEGELIN) return ACCOUNT_MEGELIN;
  if (upper === ACCOUNT_ALL) return ACCOUNT_ALL;
  return ACCOUNT_DREAME;
}

export function canViewAccountScope(tlAccount, targetAccount) {
  const scope = normalizeTlAccount(tlAccount);
  if (scope === ACCOUNT_ALL) return true;
  return scope === normalizeAccount(targetAccount);
}

export function getTlVisibleLogAccounts(tlAccount) {
  const scope = normalizeTlAccount(tlAccount);
  if (scope === ACCOUNT_ALL) return [ACCOUNT_DREAME, ACCOUNT_MEGELIN];
  if (scope === ACCOUNT_MEGELIN) return [ACCOUNT_MEGELIN];
  return [ACCOUNT_DREAME];
}
